import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "list-title" }
const _hoisted_2 = { class: "list-context" }
const _hoisted_3 = {
  key: 0,
  class: "w-full h-px bg-ternary my-8"
}

import AccordionComponent from "@/components/accordion/AccordionComponent.vue";
import { useI18n } from "vue-i18n";
import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ActivatorsAccordionFAQ',
  setup(__props) {

const { t, tm } = useI18n();

const instructionBlocks = computed(() => tm("faq.activators") as unknown);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AccordionComponent, null, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)("calculators.activations.faq.activators.title")), 1)
    ]),
    "faq-content": _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(instructionBlocks.value, (block, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
          _createElementVNode("h4", _hoisted_1, _toDisplayString(block.title), 1),
          _createElementVNode("ul", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(block.items, (item, i) => {
              return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(item), 1))
            }), 128))
          ]),
          (index < instructionBlocks.value.length - 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3))
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ]),
    "collapse-text-btn": _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)("calculators.activations.faq.activators.collapse_btn")), 1)
    ]),
    _: 1
  }))
}
}

})